import { Link } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

const style = {
  position: 'absolute',
  minWidth: '300px',
  maxWidth: '500px',
  lineHeight: '28px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  textAlign: 'left',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 3,
};

const styleCloseIcon = {
  position: 'absolute',
  top: '5px',
  right: '5px',
  cursor: 'pointer',
};

const formatRole = (role) => (role ? role.charAt(0).toUpperCase() + role.slice(1).toLowerCase() : '');

export default function TransitionsModal({ open, setOpen, role }) {
  const handleClose = () => setOpen(false);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <CloseRoundedIcon sx={styleCloseIcon} onClick={handleClose} color={'primary'} />
          <div className="userModalContainer">
            <h2>About PDF Export</h2>
            <p>
              Your current subscription plan is '{formatRole(role)}'. This feature is available only for 'Premium' and
              'Professional' plans. To use this feature, you need to upgrade your plan.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Link to="/pricing">
                <Button variant="outlined" size="small">
                  Go to Pricing
                </Button>
              </Link>
            </div>

            {/* <Button className="pricingInfoModalButton" variant="contained" onClick={handleClose}>
              Pricing
            </Button> */}
          </div>
        </Box>
      </Fade>
    </Modal>
  );
}
